module.exports = __webpack_public_path__ + "static/media/spsoft_logo.cbbbe539.webp";